<script setup lang="ts">
import { ref, watch } from 'vue'
import SectionContact from '../SectionContact.vue'
import stores from '@/storage/stores'
import Section from '../Section.vue'
import SectionHours from '../SectionHours.vue'
import { isPickup } from '@/event/footer/isPickup'

const nameStore = ref<string>('Eronor.com')

watch(
    () => stores.getStoresData(),
    () => {
        nameStore.value = stores.getStoresData().name || 'Eronor.com'
    },
    { immediate: true }
)
</script>

<template>
    <section>
        <div class="middle-footer">
            <div class="div-section">
                <SectionContact :nameStore="nameStore" title="Contact" />
                <Section title="Informations du site" />
                <SectionHours :title="isPickup" />
            </div>
        </div>
    </section>
</template>

<style scoped>
.middle-footer {
    @apply flex flex-grow bg-black w-full bottom-0 p-2 min-h-full;
    @apply smoke-white:text-white;
}
.div-section {
    @apply flex flex-col flex-grow;
}

@media screen and (min-width: 800px) {
    .div-section {
        @apply grid grid-cols-3 justify-items-center mx-auto;
    }
}

@media screen and (min-width: 1000px) {
    .div-section {
        @apply max-w-[60rem];
    }
}

@media screen and (min-width: 1280px) {
    .div-section {
        @apply max-w-[65rem];
    }
}

@media screen and (min-width: 1500px) {
    .div-section {
        @apply max-w-[70rem];
    }
}

@media screen and (min-width: 2000px) {
    .div-section {
        @apply max-w-[80rem];
    }
}
</style>
